/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react'
import { useStorage } from 'reactfire'

import { useDispatch } from 'src/store'

export type OnUpdateParam =
  | { data: null; state: 'loading' }
  | { data: any; state: 'success' }
  | { data: any; state: 'error' }

export const usePhotoUpload = (
  onUpdate: (update: OnUpdateParam) => void,
  uid: string
) => {
  const storage = useStorage()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [photoData, setPhotoData] = useState<File | null>(null)

  const handlePhotoUpload = useCallback(
    async (photoFile: File) => {
      const storageRef = storage.ref()
      const imageRef = storageRef.child(`users/${uid}/profile-picture.jpg`)

      setIsLoading(true)
      onUpdate({ data: null, state: 'loading' })

      const uploadRes = await imageRef.put(photoFile).catch((err: any) => {
        onUpdate({ data: err, state: 'error' })
      })
      const imgUrl = await imageRef.getDownloadURL().catch((err: any) => {
        onUpdate({ data: err, state: 'error' })
      })
      dispatch.user.updateUser({ profilePicture: imgUrl })

      if (imgUrl) {
        onUpdate({
          data: imgUrl,
          state: uploadRes.state === 'success' ? 'success' : 'error',
        })
      }

      setIsLoading(false)
    },
    [storage, onUpdate, uid, dispatch]
  )

  return {
    handlePhotoInput: useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || !e.target.files[0]) {
          return
        }
        setIsLoading(true)
        const photoFile = e.target.files[0]
        setPhotoData(photoFile)

        handlePhotoUpload(photoFile)
      },
      [handlePhotoUpload]
    ),
    handlePhotoUpload,
    isLoading,
    photoData,
  }
}
